import { useNavigate, useParams } from 'react-router-dom';

import { Navigate } from '~/components/utils/Navigation';

export const AppUserContentReviewRoute: React.FC = () => {
  const { appId, userContentId } = useParams();
  const navigate = useNavigate();

  if (!appId || !userContentId) {
    navigate('/');

    return null;
  }

  return <Navigate to={`/apps/${appId}/moderation?ugcId=${userContentId}`} />;
};
